import React, { useContext } from 'react';
import { Text } from 'rebass';

import { theme } from '../../styles/theme';

import { TypographyContext } from './config';

export { TypographyContextProvider } from './config';

const isLink = (variant) =>
  variant === 'link' || variant === 'linkLrg' || variant === 'linkSml';

/**
 * Renders typography elements
 * @param {Object} props
 * @param {string} props.component - Component to render or an HTML tag name.
 * @param {string} props.inline - Decides whether the default tag is `p` or `span`, has no effect if "component" is set.
 * @param {string} props.variant - Text variant from configuration object.
 */
const Typography = ({
  inline,
  component = inline ? 'span' : 'p',
  variant,
  ...other
}) => {
  const { variantMap } = useContext(TypographyContext);

  const selectedVariant = variantMap[variant || component];
  const color = isLink(selectedVariant) ? theme.text.link.color : 'inherit';

  return (
    <Text
      color={color}
      as={component}
      variant={selectedVariant}
      {...other}
      sx={{
        '&.small': {
          fontSize: [1, , 2],
        },
        '&.large': {
          fontSize: [3, , 6],
        },
        ...other.sx,
      }}
    />
  );
};

export default Typography;
